/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelnav1Inputs */

const en_channelnav1 = /** @type {(inputs: Channelnav1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Channel`)
};

const de_channelnav1 = /** @type {(inputs: Channelnav1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Channel`)
};

/**
* | output |
* | --- |
* | "Channel" |
*
* @param {Channelnav1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelnav1 = /** @type {((inputs?: Channelnav1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelnav1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelnav1(inputs)
	return de_channelnav1(inputs)
});
export { channelnav1 as "channelNav" }